export default __webpack_public_path__ + "static/media/safety.f804460d.png";